import LogRocket from 'logrocket';
import * as Sentry from '@sentry/react';
import { isAfter } from 'date-fns';
class FirebaseLogin {
    constructor(user) {
        this.user = user;
    }
    onLoginSuccess(onSuccess) {
        const userDetails = this.getUserDetails();
        this.logUserLoginSuccess(userDetails);
        const { isAnonymous } = this.user;
        const isNewAccount = localStorage.getItem('avaAccount') !== 'true' && isAnonymous;
        const firebaseAuthUID = this.user.uid;
        this.user.getIdToken().then((idToken) => {
            localStorage.setItem('prefetch_me_uid', firebaseAuthUID);
            localStorage.setItem('prefetch_me_token', idToken);
            onSuccess(Object.assign(Object.assign({}, userDetails), { idToken }), isNewAccount);
        });
        localStorage.setItem('avaAccount', 'true');
        localStorage.setItem('isAnonymous', isAnonymous);
    }
    logUserLoginSuccess(userDetails) {
        Sentry.addBreadcrumb({
            category: 'auth',
            message: JSON.stringify(userDetails),
            level: Sentry.Severity.Info,
        });
    }
    logUserSession() {
        const { email, uid } = this.user;
        const backendUrl = localStorage.getItem('scribeBackendUrl') || '';
        if (backendUrl.includes('playground') || backendUrl.includes('localhost') || backendUrl.includes('ngrok')) {
            LogRocket.identify(uid, { email });
        }
    }
    getUserDetails() {
        const { displayName, email, emailVerified, isAnonymous, photoURL, uid } = this.user;
        return { displayName, email, emailVerified, isAnonymous, photoURL, uid };
    }
    get uid() {
        return this.user.uid;
    }
    get email() {
        return this.user.email;
    }
    get emailVerified() {
        return this.user.emailVerified;
    }
    get displayName() {
        return this.user.displayName;
    }
    get isAnonymous() {
        return this.user.isAnonymous;
    }
    get photoURL() {
        return this.user.photoURL;
    }
    get creationTime() {
        return new Date(this.user.metadata.creationTime);
    }
    get lastSignInTime() {
        return new Date(this.user.metadata.lastSignInTime);
    }
    get isNew() {
        return this.user.metadata.creationTime === this.user.metadata.lastSignInTime;
    }
    get justSignedIn() {
        const now = new Date();
        const oneMinuteAgo = new Date(now.getTime() - 60 * 1000);
        return !this.isNew && isAfter(new Date(this.lastSignInTime), oneMinuteAgo);
    }
    get sessionRefreshed() {
        return !this.isNew && !this.justSignedIn;
    }
    // If the user is authenticated with their own email and password, we treat
    // them as logged out until they verify their email. This is not true for
    // users who logged in with Facebook though - their email will always be
    // unverified and we are okay with it.
    get shouldWaitForEmailVerification() {
        var _a, _b;
        const isCredentialiedUser = ((_b = (_a = this.user.providerData) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) === 1 && this.user.providerData[0].providerId === 'password';
        return this.email && !this.emailVerified && isCredentialiedUser;
    }
}
export default FirebaseLogin;
